import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { datadogRum } from '@datadog/browser-rum';
import { useEffect, useContext, useRef } from 'react';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import { useSearchRequestId } from '~/contexts/InventoryContext';
import ModalContext from '~/contexts/ModalContext/ModalContext';
import UserContext from '~/contexts/UserContext';
import {
  Heading,
  LowResultWrapper,
  SaveSearchButton,
  Subtitle
} from './SimilarResults/SimilarResultSection.styles';
import SimilarResultsSection from './SimilarResults/SimilarResultsSection';
import useHeaderAccountModal from '../useHeaderAccountModal';

const LowResultSection = () => {
  const { trackEvent } = useContext(AnalyticsContext);
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const { setCreateSavedSearchOpen } = useContext(ModalContext);
  const { triggerFetchUserProfile } = useContext(UserContext);
  const searchRequestId = useSearchRequestId();

  const openModal = () => {
    setCreateSavedSearchOpen(true, appliedFilters);
  };

  const successHandler = async () => {
    triggerFetchUserProfile();
    setCreateSavedSearchOpen(true, appliedFilters);
  };

  const handleOpenModal = useHeaderAccountModal({
    openModal,
    successHandler
  });

  const searchRequestIdRef = useRef(searchRequestId);
  useEffect(() => {
    searchRequestIdRef.current = searchRequestId;
  }, [searchRequestId]);

  useEffect(() => {
    trackEvent('Low Results Shown', {
      searchRequestId: searchRequestIdRef.current
    });

    datadogRum.addAction('Low Results Shown');
  }, [trackEvent]);

  return (
    <>
      <LowResultWrapper>
        <Heading role="heading">We didn’t find many matches</Heading>
        <Subtitle className="subtitle">
          We get more cars every day. Get vehicles you’re looking for, straight
          to your inbox!
        </Subtitle>
        <SaveSearchButton
          className="save-search-button"
          data-analytics-id="create-search-alert-lrp"
          type="button"
          onClick={handleOpenModal}
        >
          Save This Search
        </SaveSearchButton>
      </LowResultWrapper>
      <SimilarResultsSection />
    </>
  );
};

export default LowResultSection;
